module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "copyright"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("Published 2011—IMM Lifestyle Books, an imprint of Fox Chapel Publishing"), _c('br'), _c('em', [_c('a', {
    attrs: {
      "href": "http://www.foxchapelpublishing.com",
      "target": "_blank"
    }
  }, [_vm._v("www.foxchapelpublishing.com")])])]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("IMM Lifestyle Books are distributed in the UK by Grantham Book Service, Trent Road, Grantham, Lincolnshire, NG31 7XQ")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("Copyright © 2011 Ian Cooke and Fox Chapel Publishing Company, Inc., 903 Square Street, Mount Joy, PA 17552.")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("All rights reserved. No part of this publication may be reproduced, stored in a retrieval system or transmitted in any form or by any means, electronic, mechanical, photocopying, recording or otherwise, without the prior written permission of the publisher and copyright holders.")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("Print ISBN 9781504800570"), _c('br'), _vm._v("eISBN 9781607659228")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("We are always looking for talented authors. To submit an idea, please send a brief inquiry to "), _c('a', {
    attrs: {
      "href": "mailto:acquisitions@foxchapelpublishing.com"
    }
  }, [_vm._v("acquisitions@foxchapelpublishing.com")]), _vm._v(".")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aefbb34e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/copyright.vue
// module id = 66
// module chunks = 0